<div class="router-event">
    <div class="event-page-header">
        <div class="d-flex align-items-end justify-content-between header-wrapper">
            <div class="event-breadcrumb">
                <h1 class="title-detail-event m-0">Eventos</h1>
                <mat-divider [vertical]="true" class="breadcrumb-divider"></mat-divider>
                <h1 class="title-detail-event m-0">{{title}}</h1>
            </div>
            <div class="d-flex align-items-center link-open-event">
                <i class="fal fa-link pointer-in"></i>
                <a [href]="openLinkEvent()" target="_blank">Ver evento en Citylok</a>
                <i class="fa-light fa-copy" style="margin-left: 0.625rem;" (click)="copyLink()"></i>
            </div>
        </div>
        <mat-divider class="divider-title"></mat-divider>
    </div>
    <div class="btn-back-detail" (click)="goBack()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los eventos</span>
    </div>
    <div class="d-flex info-panel page-panel">
        <app-menu-events class="d-lg-none" [idEvent]="event" [draft]="isDraftEvent" [eventType]="eventType"
            (changeTab)="changeMenuEvent($event)"></app-menu-events>
        <div class="card-white-panel">
            <div *ngIf="event">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
